<template>
  <div class="pre-view wrapper-primery">
    <ul class="tabs wrapper-secondary">
      <li class="tab" :class="isActive(1)" @click="selectTab(1)">
        {{ $t("Live") }}
      </li>
      <li class="tab" :class="isActive(2)" @click="selectTab(2)">
        {{ $t("Prematch") }}
      </li>
      <li class="tab" :class="isActive(3)" @click="selectTab(3)">
        {{ $t("Ticker") }}
      </li>
    </ul>

    <div class="slots">
      <div class="slot" :class="isActive(1)">
        <picture>
          <!-- <source media="(max-width: 767px)" srcset="/pic/picture/picture-tab-mob.webp" type="image/webp" />
          <source media="(max-width: 767px)" srcset="/pic/picture/picture-tab-mob.png" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/picture-tab-tablet.webp" type="image/webp" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/picture-tab-tablet.png" />
          <source srcset="/pic/picture/picture-tab.webp" type="image/webp" />
          <img src="/pic/picture/picture-tab.png" style="width: 664px; height: 460px;" width="664" height="460"
            alt="live" loading="lazy"/> -->
          <img :src="liveSrc" alt="picture" loading="lazy" />
        </picture>
        <div class="slot-text wrapper-secondary">
          <div class="slot-header">
            <div class="slot-logo">
              <LiveIcon />
            </div>
            <h4 class="slot-title">{{ $t("Live") }}</h4>
          </div>

          <p>
            {{ $t("pre_view_live") }}
          </p>
          <a href="#sub_id">
            <CustomButton
              class="choose-btn"
              type="prime"
              :class="{ short: true }"
            >
              {{ $t("try_free") }}
            </CustomButton>
          </a>
        </div>
      </div>
      <div class="slot" :class="isActive(2)">
        <picture>
          <!-- <source media="(max-width: 767px)" srcset="/pic/picture/prematch-tab-mob.webp" type="image/webp" />
          <source media="(max-width: 767px)" srcset="/pic/picture/prematch-tab-mob.png" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/prematch-tab.webp" type="image/webp" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/prematch-tab.png" />
          <source srcset="/pic/picture/prematch-tab.webp" type="image/webp" />
          <img src="/pic/picture/prematch-tab.png" style="width: 664px; height: 460px;" width="664" height="460"
            alt="picture" loading="lazy"/> -->
          <img :src="prematchSrc" alt="picture" loading="lazy" />
        </picture>
        <div class="slot-text wrapper-secondary">
          <div class="slot-header">
            <div class="slot-logo">
              <PrematchIcon />
            </div>
            <h4 class="slot-title">{{ $t("Prematch") }}</h4>
          </div>
          <p>
            {{ $t("pre_view_prematch") }}
          </p>
          <a href="#sub_id">
            <CustomButton
              class="choose-btn"
              type="prime"
              :class="{ short: true }"
            >
              {{ $t("try_free") }}
            </CustomButton>
          </a>
        </div>
      </div>
      <div class="slot" :class="isActive(3)">
        <picture>
          <!-- <source media="(max-width: 767px)" srcset="/pic/picture/ticker-tab-mob.webp" type="image/webp" />
          <source media="(max-width: 767px)" srcset="/pic/picture/ticker-tab-mob.png" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/ticker-tab.webp" type="image/webp" />
          <source media="(max-width: 1023px)" srcset="/pic/picture/ticker-tab.png" />
          <source srcset="/pic/picture/ticker-tab.webp" type="image/webp" />
          <img src="/pic/picture/ticker-tab.png" style="width: 664px; height: 460px;" width="664" height="460"
            alt="ticker" loading="lazy"/> -->
          <img :src="tickerSrc" alt="picture" loading="lazy" />
        </picture>
        <div class="slot-text wrapper-secondary">
          <div class="slot-header">
            <div class="slot-logo">
              <TickerIcon />
            </div>
            <h4 class="slot-title">{{ $t("Ticker") }}</h4>
          </div>
          <p>
            {{ $t("pre_view_ticker") }}
          </p>
          <a href="#sub_id">
            <CustomButton
              class="choose-btn"
              type="prime"
              :class="{ short: true }"
            >
              {{ $t("try_free") }}
            </CustomButton>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiveIcon from "../common/icons/Live.vue";
import TickerIcon from "../common/icons/Ticker.vue";
import PrematchIcon from "../common/icons/Prematch.vue";
import CustomButton from '../common/form/CustomButton.vue';

export default {
  name: "PreView",
  components: { LiveIcon, TickerIcon, PrematchIcon, CustomButton },
  data() {
    return {
      activeTab: 1,
    };
  },
  computed: {
    prematchSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/pre-view/dark-w996-prematch.jpg"
        : "/pic/subscribe/pre-view/light-w996-prematch.jpg";
    },
    tickerSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/pre-view/dark-w996-ticker.jpg"
        : "/pic/subscribe/pre-view/light-w996-ticker.jpg";
    },
    liveSrc() {
      return this.isDarkTheme
        ? "/pic/subscribe/pre-view/dark-w996-live.jpg"
        : "/pic/subscribe/pre-view/light-w996-live.jpg";
    },
    isDarkTheme() {
      return this.$store.getters.isDarkTheme;
    },
  },
  methods: {
    selectTab(key) {
      this.activeTab = key;
    },
    isActive(key) {
      switch (true) {
        case key == this.activeTab:
          return "active";
        case key > this.activeTab:
          return "before";
        case key < this.activeTab:
          return "after";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.pre-view {
  margin-top: 45px;
}

.tabs {
  display: flex;
  gap: 20px;
  padding: 15px 25px;
  margin: 0 0 32px 0;

  .active {
    color: var(--body-color);
    background: var(--back-color);
  }
}

.tab {
  cursor: pointer;
  padding: 15px 30px;
  width: 100%;
  font-weight: 600;
  text-align: center;
  line-height: 1.188;
  border-radius: 16px;
  color: var(--back-color);
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: var(--body-color-third);
  transition: 0.3s all;

  &:hover {
    color: var(--brand-color);
    box-shadow: -1px -1px 4px -2px var(--brand-color);
  }
}

.slots {
  position: relative;
  display: flex;
  overflow: hidden;
}

.slot {
  display: flex;
  gap: 32px;
  opacity: 0;
  filter: blur(10px);
  transition: all 0.5s linear;

  &.active {
    position: relative;
    opacity: 1;
    filter: blur(0);
  }

  &.before {
    position: absolute;
    transform: translateX(100%);
    overflow: hidden;
  }

  &.after {
    position: absolute;
    transform: translateX(-100%);
    overflow: hidden;
  }
}

.slot-text {
  width: 45%;
  font-size: 18px;
}

.slot-title {
  margin: 0 0 22px;
  line-height: 1.2;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: var(--back-color);
  font-size: 28px;
}

.slot-link {
  display: inline-block;
  color: var(--brand-color);
  font-size: 20px;
  margin-top: 30px;

  &:after {
    content: "→";
    padding: 0 0 0 1px;
    transition: 0.3s all;
  }

  &:hover,
  &:active,
  &:focus {
    border-bottom: solid 1px var(--brand-color);
  }
}

.slot-logo {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 0 0 30px;
  width: 88px;
  height: 88px;
  border-radius: 100%;
  background: var(--body-color);
  box-shadow: -1px -1px 4px -2px rgb(255, 255, 255);
}

img {
  max-width: 100%;
  width: 100%;
  border-radius: 26px;
  background: var(--body-color);
  overflow: hidden;
  aspect-ratio: auto;
  object-fit: cover;
  height: 700px;
}

@media screen and (max-width: $fullhd) {
  .slot {
    align-items: center;
    flex-direction: column;
  }

  .slot-text {
    width: 100%;
  }
}

@media screen and (max-width: 1160px) {
  img {
    height: 500px;
  }
}
@media screen and (max-width: 900px) {
  img {
    height: 350px;
  }
}

@media screen and (max-width: 450px) {
  img {
    height: 250px;
  }
}

@media screen and (max-width: $mobile) {
  .tabs {
    gap: 10px;
    padding: 10px;
  }

  .tab {
    font-size: 12px;
    padding: 15px 20px;
  }

  .slot-logo {
    width: 70px;
    height: 70px;
  }

  .slot-header {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  img {
    height: 250px;
  }
}
@media screen and (max-width: 450px) {
  img {
    height: 200px;
  }
}
</style>
